import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  div {
    > p {
      margin: 20px 0px;
      color: var(--color-primary);
      font-size: 16px;
      line-height: 16px;
      font-weight: 700;
    }
  }
`;

export const ResumoContainer = styled.table`
  border-collapse: collapse;
  margin: 25px 0px;
  width: 1075px;
  overflow: hidden;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);

  thead tr {
    background: var(--color-primary);
    color: #fff;
    font-weight: 700;
  }
  th {
    font-size: 12px;
    padding: 10px 2px;
  }
`;

interface TableItemProps {
  isEditable?: boolean;
}

export const TableItem = styled.tr`
  &:last-child {
    background: var(--color-primary);
  }
`;

export const TableItemContent = styled.td<TableItemProps>`
  color: ${(props) => (props.isEditable ? '#707070' : ' #c4c4c4')};
  width: 130px;
  height: 25px;
  text-align: center;
  font-size: 12px;
  font-weight: 700;
`;

export const ActionsButtons = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
  width: 110px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  cursor: pointer;

  img {
    width: 15px;
    height: 25px;

    &:first-child {
      width: 25px;
    }
  }
`;
